export enum UpdateTypeEnum {
    Unknown = 0,
    Firmware = 1,
    SensorFirmware = 2,
    SensorTemplate = 3,
    Agent = 4,
    AstVal = 5,
    Caos = 6,
    SensorLicense = 7,
    R8cFirmware = 8,
    ThirdPartySoftware = 9,
    MensFirmware = 10,
    InLaneSw = 11,
    CHController = 12,
    CustomAction = 13,
}

export function GetEnumFromValue(val: number): UpdateTypeEnum {
    let res = UpdateTypeEnum.Unknown;
    switch (val) {
        case 1: {
            res = UpdateTypeEnum.Firmware;
            break;
        }
        case 2: {
            res = UpdateTypeEnum.SensorFirmware;
            break;
        }
        case 3: {
            res = UpdateTypeEnum.SensorTemplate;
            break;
        }
        case 4: {
            res = UpdateTypeEnum.Agent;
            break;
        }
        case 5: {
            res = UpdateTypeEnum.AstVal;
            break;
        }
        case 6: {
            res = UpdateTypeEnum.Caos;
            break;
        }
        case 7: {
            res = UpdateTypeEnum.SensorLicense;
            break;
        }
        case 8: {
            res = UpdateTypeEnum.R8cFirmware;
            break;
        }
        case 9: {
            res = UpdateTypeEnum.ThirdPartySoftware;
            break;
        }
        case 10: {
            res = UpdateTypeEnum.MensFirmware;
            break;
        }
        case 11: {
            res = UpdateTypeEnum.InLaneSw;
            break;
        }
        case 12: {
            res = UpdateTypeEnum.CHController;
            break;
        }
        case 13: {
            res = UpdateTypeEnum.CustomAction;
            break;
        }
        default: {
            res = UpdateTypeEnum.Unknown;
            break;
        }
    }

    return res;
}

export function GetI18nStringFromUpdateType(val: UpdateTypeEnum): string {
    let res = "";
    switch (val) {
        case UpdateTypeEnum.Unknown:
            res = "enum.update_type.unknown";
            break;
        case UpdateTypeEnum.Firmware:
            res = "enum.update_type.firmware";
            break;
        case UpdateTypeEnum.SensorFirmware:
            res = "enum.update_type.sensor_firmware";
            break;
        case UpdateTypeEnum.SensorTemplate:
            res = "enum.update_type.sensor_template";
            break;
        case UpdateTypeEnum.Agent:
            res = "enum.update_type.agent";
            break;
        case UpdateTypeEnum.AstVal:
            res = "enum.update_type.ast_val";
            break;
        case UpdateTypeEnum.Caos:
            res = "enum.update_type.caos";
            break;
        case UpdateTypeEnum.SensorLicense:
            res = "enum.update_type.sensor_license";
            break;
        case UpdateTypeEnum.R8cFirmware:
            res = "enum.update_type.r8c_firmware";
            break;
        case UpdateTypeEnum.ThirdPartySoftware:
            res = "enum.update_type.third_party_software";
            break;
        case UpdateTypeEnum.MensFirmware:
            res = "enum.update_type.mens_firmware";
            break;
        case UpdateTypeEnum.InLaneSw:
            res = "enum.update_type.inLane_sw";
            break;
        case UpdateTypeEnum.CHController:
            res = "enum.update_type.ch_controller";
            break;
        case UpdateTypeEnum.CustomAction:
            res = "enum.update_type.custom_action";
            break;
        default:
            res = "enum.update_type.unknown";
            break;
    }

    return res;
}
